// F-MOTOR-RESERVAS.3.0 — camada de acesso às APIs públicas (2.E).
// Usa o axios `publicApi` já configurado em lib/api.js (sem credenciais).
// Nenhum endpoint é adicionado aqui; apenas consome o que o backend já expõe.

import { publicApi, API } from "./api";

export async function listPousadas() {
  const { data } = await publicApi.get("/public/pousadas");
  return Array.isArray(data) ? data : [];
}

export async function getPousada(slugOrId) {
  const { data } = await publicApi.get(`/public/pousadas/${encodeURIComponent(slugOrId)}`);
  return data;
}

export async function getPousadaFotos(pousadaId) {
  const { data } = await publicApi.get(`/public/pousadas/${encodeURIComponent(pousadaId)}/fotos`);
  return Array.isArray(data) ? data : [];
}

export async function getPousadaQuartos(pousadaId) {
  const { data } = await publicApi.get(`/public/pousadas/${encodeURIComponent(pousadaId)}/quartos`);
  return Array.isArray(data) ? data : [];
}

export async function getQuarto(quartoId) {
  const { data } = await publicApi.get(`/public/quartos/${encodeURIComponent(quartoId)}`);
  return data;
}

export async function getQuartoFotos(quartoId) {
  const { data } = await publicApi.get(`/public/quartos/${encodeURIComponent(quartoId)}/fotos`);
  return Array.isArray(data) ? data : [];
}

// URL direta da foto (endpoint público serve o binário).
export function fotoUrl(fotoId) {
  if (!fotoId) return null;
  return `${API}/public/fotos/${encodeURIComponent(fotoId)}`;
}

// F-MOTOR-RESERVAS.3.1.4 — motor de reserva público (3.1.1/3.1.2/3.1.3).
// Contrato autoritativo é do backend; frontend NUNCA calcula preço.

/**
 * GET /public/disponibilidade — lista quartos elegíveis com motivo/detalhe.
 * @param {{data_entrada:string, data_saida:string, num_pessoas:number,
 *          pousada_id?:string, cafe_tipo?:string}} params
 */
export async function getDisponibilidade(params) {
  const { data } = await publicApi.get("/public/disponibilidade", { params });
  return data;
}

/**
 * POST /public/cotacao — cotação pontual de 1 quarto.
 * Retorna `{disponivel, motivo?, diarias, valor_diaria, subtotal_hospedagem,
 * cafe_*, total}`.
 */
export async function postCotacao(payload) {
  const { data } = await publicApi.post("/public/cotacao", payload);
  return data;
}

/**
 * POST /public/reservas — cria pré-reserva (status="pre-reserva").
 * Envia o Idempotency-Key como header. 201 na primeira chamada, 201 idempotente
 * na segunda chamada com a mesma key.
 */
export async function postReserva(payload, { idempotencyKey } = {}) {
  const headers = {};
  if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;
  const { data } = await publicApi.post("/public/reservas", payload, { headers });
  return data;
}
